export default function IconUps({ className }: { className?: string }) {
    return (
        <svg
            className={className}
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="13"
            viewBox="0 0 12 13"
            fill="none"
        >
            <path
                d="M0.136719 6.66568C0.136719 9.23285 1.72817 11.4214 3.96844 12.2808V1.05133C1.72775 1.91078 0.136719 4.09892 0.136719 6.66568ZM6.0701 0.666504C5.90582 0.666504 5.7432 0.672297 5.58224 0.684297V1.10637H5.61244C7.87382 1.12292 9.69451 2.86664 9.67837 5.0014C9.66348 7.12623 7.8312 8.83726 5.58306 8.83519V12.6475C5.7432 12.6611 5.90624 12.6665 6.07051 12.6665C9.3461 12.6665 12.0043 9.97975 12.0043 6.66568C12.0043 3.35202 9.34568 0.666504 6.0701 0.666504Z"
                fill="#DC1928"
            />
        </svg>
    )
}
